module.exports = __webpack_public_path__ + "media/images/icons/minus_white-1b3802e57dea12a476f058d27d79577d.svg";